import { useRef, useState } from "react";
import "./styles.css";

export default function Password({ onResponse }) {
  const inputRef = useRef(null);
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    const password = inputRef.current.value.trim();
    if (!password) return;

    setLoading(true);

    try {
      const res = await fetch("https://backend-icy-sky-7649.fly.dev", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ password }), // send password attempt to Go
      });

      const data = await res.json();
      console.log("Response from Go:", data);

      // send response back to parent (App.js)
      if (onResponse) onResponse(data);

      inputRef.current.value = "";
    } catch (err) {
      console.error("Error sending password:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();   // prevents page reload
    handleClick();        // existing logic
  };

  return ( 
  <form onSubmit={handleSubmit}>
    <input
      type="text"
      ref={inputRef}
      placeholder="Enter Password"
      disabled={loading}
      className="passwordInput"
    />
    <button type="submit" disabled={loading}>
      {loading ? "Sending..." : "Submit"}
    </button>
  </form>
);
}

